import { UrlMatcher, UrlMatchResult, UrlSegment } from "@angular/router";
import {
  APP_ROUTES,
  ROUTE_SEGMENTS,
} from "@shared/constants/app-routes.constants";

/**
 * The router reuses a component only while the matched `routeConfig` is the
 * same object, so a bare link redirecting to its first price and a switch
 * between sibling prices both keep the shell instance, its loaded package and
 * its stores.
 */
export const editPackageMatcher = ((
  segments: UrlSegment[],
): UrlMatchResult | null => {
  const [head, id, mid, pop] = segments;
  if (head?.path !== ROUTE_SEGMENTS.EDIT_PACKAGE || !id?.path) return null;
  if (segments.length === 2) return { consumed: segments, posParams: { id } };
  if (segments.length === 4 && mid.path === ROUTE_SEGMENTS.PRICE && pop.path) {
    return { consumed: segments, posParams: { id, popId: pop } };
  }
  return null;
}) satisfies UrlMatcher;

export function editPackageCommands(
  packageId: string,
  popId?: string | null,
): string[] {
  const commands = [
    APP_ROUTES.MANAGEMENT.ENRICHMENT_PRICE.EDIT_PACKAGE,
    packageId,
  ];
  return popId ? [...commands, ROUTE_SEGMENTS.PRICE, popId] : commands;
}
